

import Event = createjs.Event;

export class BasicToolTipEvent extends Event {
    public static TOOLTIP_HIDE: string = "tooltiphide";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
        this.params = params;
    }

}

